import { useEffect } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { attachBackButton } from "../lib/native";

// Корневые экраны: отсюда системная «Назад» сворачивает приложение,
// а не закрывает его на полпути по каталогу.
const ROOT_PATHS = ["/app/home", "/app/catalog", "/", "/auth"];

/** Системная кнопка «Назад» в Android-сборке. В браузере ничего не делает. */
export function useAndroidBackButton() {
  const navigate = useNavigate();
  const location = useLocation();

  useEffect(() => {
    let detach = () => {};
    let cancelled = false;

    (async () => {
      const off = await attachBackButton(async ({ canGoBack }) => {
        const openDialog = document.querySelector('[role="dialog"][data-state="open"], [role="dialog"]:not([hidden])');
        if (openDialog) {
          const close = openDialog.querySelector('[data-testid$="-close"], [aria-label="Закрыть"]');
          if (close) { close.click(); return; }
        }
        if (!ROOT_PATHS.includes(location.pathname)) {
          // Открыто по пуш-ссылке — истории нет, уводим на главную, а не закрываем
          if (canGoBack) navigate(-1); else navigate("/app/home", { replace: true });
          return;
        }
        const { App } = await import("@capacitor/app");
        App.minimizeApp();
      });
      if (cancelled) off(); else detach = off;
    })();

    return () => { cancelled = true; detach(); };
  }, [navigate, location.pathname]);
}

export default useAndroidBackButton;
